import {spring} from 'react-motion';

export const FADE_IN_LEFT = {
  enter: {opacity: 1, translateX: spring(0, {stiffness: 300, damping: 20})},
  leave: {opacity: 0, translateX: -100},
};
